import React from 'react';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import createLinkPlugin from '@draft-js-plugins/anchor';
import {
    CompositeDecorator,
} from 'draft-js'

const Link = props => {
    // console.log('[Link]', props)
    if(props.href){
        return (
            <a href={props.href} target="_blank" onClick={() => window.open(props.href)}>
                {props.children}
            </a>
        );
    } else {
        const { contentState, entityKey } = props;
        let { url } = contentState.getEntity(entityKey).getData();
        if(!url.includes('https://')){
            url = 'https://' + url
        }

        return (
            <a href={url} target="_blank" onClick={() => window.open(url)}>
                {props.children}
            </a>
        );
    }
};

const linkifyPlugin = createLinkifyPlugin({
    component(linkProps) {
        return <Link {...linkProps}/>
    },
});

const linkPlugin = createLinkPlugin({
    Link: linkProps => {
        return <Link {...linkProps}/>
    }
});

export const LinkifyDecorator = () => {
    return new CompositeDecorator(linkifyPlugin['decorators'])
}

export const AnchorDecorator = () => {
    return new CompositeDecorator(linkPlugin['decorators'])
}